import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManageCountyPage = React.lazy(() => import(/* webpackChunkName: "AdminManageCounty" */ './Page'));
export const AdminManageCounty = () => (React.createElement(Page, { title: "Administrator Manage County" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminManageCountyPage, null)))));
